import { useState } from 'react';

import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  WithLightTitle,
} from '@randstad-lean-mobile-factory/react-components-core';
import { TextInput, useFormWithZodResolver } from '@randstad-lean-mobile-factory/react-form-fields';
import { z } from 'zod';

import { useCreateUser } from 'src/Hooks/MbapiAdmin/useCreateUser';

const schema = z.object({
  username: z.string().min(5).max(32),
  password: z.string().min(20),
});

export const CreateUserModal = () => {
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);

  const { control, reset, handleSubmit } = useFormWithZodResolver({
    schema: schema,
    defaultValues: { username: '', password: '' },
  });

  const createUser = useCreateUser({
    onSuccess: () => {
      setTimeout(() => setIsUserModalOpen(false), 500);
    },
    onSettled: () => {
      setTimeout(() => createUser.reset(), 500);
    },
  });

  return (
    <>
      <Button
        size="medium"
        onClick={() => {
          reset();
          setIsUserModalOpen(true);
        }}
      >
        ajouter un utilisateur
      </Button>
      <Modal size="medium" open={isUserModalOpen} onClose={() => setIsUserModalOpen(false)}>
        <ModalContent title="créer un utilisateur">
          <WithLightTitle title="nom d'utilisateur">
            <TextInput control={control} name="username" />
          </WithLightTitle>
          <WithLightTitle title="mot de passe">
            <TextInput control={control} name="password" type="password" />
          </WithLightTitle>
        </ModalContent>
        <ModalActions side="right">
          <Button
            onClick={handleSubmit(values => createUser.mutateAsync(values))}
            mutationStatus={createUser.status}
          >
            valider
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};
